import * as styles from "./StreetLeague.module.css";

import { HtmlOutput } from "@components/html";
import React from "react";
import { StaticImage } from "gatsby-plugin-image";

/**
 * A component that renders a section for the Street League logo and related
 * content on the careers page.
 *
 * @param {{ title: string, content: string }} props
 * The props object containing the title and content to be rendered in the
 * component.
 * @returns {JSX.Element} The rendered component.
 */
const StreetLeague = ({
  title,
  content,
}: {
  title: string;
  content: string;
}) => {
  return (
    <section className={`inner ${styles.slContainer}`}>
      <div className={styles.slText}>
        <h2>{title}</h2>
        <HtmlOutput html={content} />
      </div>
      <div className={styles.slLogoContainer}>
        <StaticImage
          src="../../../../../images/street-league-logo.png"
          alt="Street League Logo"
          width={200}
          layout={"fixed"}
        />
      </div>
    </section>
  );
};

export default StreetLeague;
